import { getToken, messaging, onMessage } from "@/firebase";
import notificationSoundFile from "@/assets/notification.wav";

export default {
  name: "FirebaseMixin",
  data() {
    return {};
  },
  mounted() {
    const getters = this.$store.getters;
    if (getters.loggedin && getters.isSupp) {
      this.requestNotificationPermission();
      const channel = new window.BroadcastChannel("sw-messages");
      channel.addEventListener("message", (event) => {
        const notificationSound = new Audio(notificationSoundFile);
        notificationSound.play().catch((err) => {
          console.log(err);
        });
        this.$store.commit("increaseNotification");
      });
      onMessage(messaging, (payload) => {
        const notificationSound = new Audio(notificationSoundFile);
        this.$store.commit("increaseNotification");
        notificationSound.play().catch((err) => {
          console.log(err);
        });
      });
    }
  },
  watch: {
    "$store.getters.loggedin"(val) {
      if (val) {
        this.requestNotificationPermission();
      }
    },
  },
  methods: {
    async requestNotificationPermission() {
      try {
        const permission = await Notification.requestPermission();
        if (permission === "granted") {
          this.getToken();
        }
      } catch (error) {
        console.error("Unable to get permission to notify.", error);
      }
    },
    async getToken() {
      try {
        const currentToken = await getToken(messaging, {
          vapidKey:
            "BE3ECqnMt73LUrN_GNrGcLGJek9UmC1Sx93O9R8bX_9a5NgSrZgPKzEwVAx145kQS361poqMKUXtaEXlp1xMTkI",
        });
        if (currentToken) {
          const savedToken = this.$store.getters.fcmToken;
          if (!savedToken || savedToken != currentToken) {
            this.$store.commit("saveFcmToken", currentToken);
            this.sendToken(currentToken);
          }
          console.log(currentToken);
        } else {
          console.log("No registration token available.");
        }
      } catch (err) {
        console.error("Error subscribing to topic:", err);
      }
    },
    sendToken(token) {
      this.$store
        .dispatch("public__request", {
          config: {
            url: "supplier/notification",
            method: "post",
          },
          data: {
            token: token,
          },
        })
        .then((res) => {
          console.log(res);
        });
    },
  },
};
